export default __webpack_public_path__ + "static/media/property_inspector_feature.cfa2d449.png";